import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import testSlice from "./slices/testSlice";
import patientSlice from "./slices/patientSlice"
import langSlice from "./slices/langSlice";
import diseaseSlice from "./slices/diseaseSlice";
import applyPromoCodeSlice from "./slices/applyPromoCodeSlice"
import validatePromoCode from "./slices/validatePromoCodeSlice"
import testDataSlice  from "./slices/testDataSlice";
import specialDependentSlice from "./slices/specialDependentSlice";

const store = configureStore({
    reducer: {
        authSlice,
        testSlice,
        patientSlice,
        langSlice,
        diseaseSlice,
        applyPromoCodeSlice,
        validatePromoCode,
        testDataSlice,
        specialDependentSlice,
    }
})

export default store
